"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function TheLegendsArrival() {
  return <section data-section-id="234862" id="oriental-world-corporation-limited" className="dark bg-background text-foreground relative min-h-screen md:min-h-[90vh] w-full overflow-hidden flex items-center">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/hong_kong_port_logistics.png')] bg-cover bg-center bg-no-repeat opacity-40 mix-blend-luminosity scale-110 md:scale-105 animate-pulse duration-[10000ms]" />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/90 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-background/40" />
      </div>

      {}
      <div className="absolute inset-0 z-0 flex items-center justify-center pointer-events-none overflow-hidden">
        <span className="text-[20vw] md:text-[35vw] font-default font-black text-muted/5 tracking-tighter leading-none select-none translate-y-12">
          OWC
        </span>
      </div>

      {}
      <div className="container relative z-10 mx-auto px-4 md:px-8 h-full flex flex-col md:flex-row items-center justify-center md:justify-between gap-6 md:gap-12 py-8 md:py-20">
        
        {}
        <div className="flex-1 flex flex-col items-center md:items-start justify-center space-y-8 w-full md:max-w-2xl pt-4 md:pt-0">
          <div className="space-y-2 md:space-y-4">
            <h1 className="font-default font-black uppercase leading-[0.85] tracking-tighter text-transparent bg-clip-text bg-gradient-to-br from-foreground to-foreground/70 drop-shadow-sm !text-4xl md:!text-7xl lg:!text-8xl text-center md:text-left">
              ORIENTAL WORLD CORPORATION LIMITED.
            </h1>
          </div>
          
          <p className="text-sm md:text-lg lg:text-xl text-muted-foreground font-sans w-full md:max-w-lg leading-relaxed text-center md:text-left">
            Based in Hong Kong, we specialize in industrial oils and biofuel feedstocks for global energy markets.
          </p>

          <div className="pt-2 md:pt-4 flex justify-center md:justify-start w-full">
            <Button asChild size="lg" className="h-12 md:h-16 px-4 md:px-8 bg-primary hover:bg-primary/90 text-primary-foreground rounded-md shadow-md transition-all hover:-translate-y-1 group border-b-4 border-r-4 border-black/40">
              <Link to="https://trusting-sunbird.10web.cloud/products/">
                <span className="flex items-center gap-3 font-default font-bold text-sm md:text-lg tracking-wide uppercase">
                  View Products
                  <ArrowRight className="w-6 h-6 group-hover:translate-x-2 transition-transform duration-300" />
                </span>
              </Link>
            </Button>
          </div>
        </div>

      </div>
    </section>;
}